import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const StageLabel = ({stage}) => {

    return (
        <div className="d-flex flex-row align-items-center justify-content-start">
            <FontAwesomeIcon color="#83a6ed" icon="angle-double-right"/>
            <p className="font-weight-light p-0 m-0 pl-2">{stage}</p>
        </div>
    )

}

StageLabel.propTypes = {
    stage: PropTypes.string.isRequired
}

export default StageLabel